var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-heading d-flex align-items-center"},[_c('i',{class:_vm.iconClass}),_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.heading))]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }